import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import sampleImage from "../../assets/Braiders/kak2.png";

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={onClick}
      className="w-full text-left py-3 sm:py-4 px-4 sm:px-6 flex items-center justify-between bg-[#F3FAF9] hover:bg-[#e6f1f0] transition-colors"
      aria-expanded={isOpen}
      aria-controls={`${title.replace(/\s+/g, "-")}-content`}
    >
      <span className="uppercase text-xs sm:text-sm tracking-wide text-gray-700">
        {title}
      </span>
      {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
    </button>
    {isOpen && (
      <div id={`${title.replace(/\s+/g, "-")}-content`} className="px-4 sm:px-6 pb-4 text-gray-700 text-sm leading-relaxed">
        {children}
      </div>
    )}
  </div>
);

export default function GrowthBraider() {
  const [openIndex, setOpenIndex] = useState(0);
  const toggleIndex = (index) => setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <section className="max-w-6xl mx-auto mt-10 sm:mt-12 px-4 sm:px-6 grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-10 items-start mb-16 sm:mb-20">
      {/* Image always on the left */}
      <div className="order-1 w-full">
        <img
          src={sampleImage}
          alt="Growth braider website preview"
          className="w-full h-56 sm:h-72 md:h-[500px] object-cover rounded-lg"
          loading="lazy"
        />
      </div>

      {/* Text */}
      <div className="order-2">
        <p className="uppercase text-xs sm:text-sm text-[#c6884a] tracking-widest mb-2">Grow Your Business</p>
        <h2 className="text-2xl sm:text-3xl md:text-4xl text-gray-900 mb-3 sm:mb-4">Growth & Marketing Bundle</h2>
        <p className="text-gray-700 mb-6 sm:mb-8 text-sm sm:text-base">
          Ideal for braiders who want to stand out and grow their clientele with professional branding + marketing.
        </p>

        <div className="border border-gray-200 rounded-lg overflow-hidden shadow-sm">
          <AccordionItem title="What's Included" isOpen={openIndex === 0} onClick={() => toggleIndex(0)}>
            <ul className="list-disc list-inside space-y-1 mt-3">
              <li>3–5 page custom website (Home, Services, Gallery, About, Booking)</li>
              <li>Online booking + payment integration (Square, PayPal, Stripe)</li>
              <li>Instagram & Facebook branding setup</li>
              <li>1-month social media starter pack (15 graphics + captions)</li>
              <li>Google Business Profile setup for reviews</li>
              <li>SEO optimization for local braiding services</li>
              <li>Blog or promo page for specials</li>
            </ul>
          </AccordionItem>

          <AccordionItem title="Best For" isOpen={openIndex === 1} onClick={() => toggleIndex(1)}>
            <p className="mt-3">Braiders who want a full professional brand presence plus marketing tools to grow quickly.</p>
          </AccordionItem>
        </div>

        {/* CTA */}
        <div className="mt-5 sm:mt-6 flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
          <p className="text-gray-700 text-base sm:text-lg">
            <span className="italic">Investment begins at:</span> <span className="text-xl sm:text-2xl text-gray-900 font-medium">$1,000</span>
          </p>
          <a href="/contact" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto bg-[#C18343] text-white uppercase tracking-widest px-5 sm:px-6 py-3 text-xs sm:text-sm hover:bg-[#a76e33] transition-colors rounded-md">
              Upgrade My Business
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}
